export const redeemStepsMock = [
  { id: 1, label: 'Send your NFT to us.' },
  { id: 2, label: 'Verify the redeemable NFT and void it once verified.' },
  { id: 3, label: 'Once the NFT is verified and voided, the physical goods is shipped out immediately.' },
];
